module.exports = __webpack_public_path__ + "static/SpotifyBirthday-8e89c3917b5437c0592f17277b298dd1.png";